<template>
  <v-btn size="x-small" v-on:click="dialog = true">
    <template v-slot:prepend>
      <v-icon :icon="['fas', 'repeat']" />
    </template>
    <span v-if="updating">Обновляю данные отчёта</span>
    <span v-else>Обновить данные отчёта</span>
  </v-btn>

  <v-dialog v-model="dialog" persistent width="700" style="backdrop-filter: blur(20px)">
    <v-card rounded="xl" flat class="align-center">
      <template v-slot:title>
        <p>Обновить данные отчёта</p>
      </template>
      <template v-slot:text>
        <grdn-calendar v-model="local_range" range />
      </template>
      <template v-slot:actions>
        <v-btn @click="dialog = false" v-if="!updating" rounded="xl" color="brown">ОТМЕНА</v-btn>
        <v-spacer />
        <v-btn v-if="local_range" rounded="xl" color="light-green" @click="get_report_data()" :disabled="updating">
          Обновить данные отчёта
        </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import { Rep_Contract, Rep_Contracts, Rep_Edite_Mode, Rep_Period } from "@/store/report/SmallStorrage";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { isLoader } from "@/store/Loader";
import { ReportData } from "@/store/report/ReportData";
import GrdnCalendar from "@/components/grdn/grdn-calendar.vue";
import {compare_entering_data} from "@/libs/rm/compare_reports";

export default {
  name: "UpdateReportDialog",
  components: { GrdnCalendar },
  beforeMount() {
    this.local_range = this.range
  },
  mounted() {

  },
  data() {
    return {
      updating: false,
      local_range: null,
      selected_btn: null,
      report: {
        name: null
      },
      dialog: false
    }
  },
  methods: {
    get_report_data: function () {
      console.log('Обновляус')
      this.updating = true

      let body = {
        ObjectGUID: this.contract,
        dateStart: this.local_range.start,
        dateEnd: this.local_range.end
      }

      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetReport`
      let raw = JSON.stringify(body)

      let requestOptions = {
        method: 'POST',
        body: raw,
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(result => {
            let updated_data = compare_entering_data(result, this.report_data)
            this.report_data.section_list = updated_data.section_list
            this.report_data.data = updated_data.data

            /*let new_data = JSON.parse(result)
            for (let [index, report] of new_data.data.entries()) {
              report.uuid = this.report_data.data[index].uuid
            }
            for (let section of this.report_data.section_list) {
              for (let group of section.groups) {
                for (let report of group.reports) {
                  let new_array = new_data.data.find(element => element.unique_guid === report.unique_guid)
                  report.report_data = new_array.report_data
                }
              }
            }*/
            this.updating = false
            this.dialog = false
            this.range = this.local_range
            console.log('Обновлено!')
          })
          .catch(error => {
            this.updating = false
            this.dialog = false
            console.log(error)
          })
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    isLoading: {
      get() {
        return isLoader().get()
      },
      set(value) {
        return isLoader().set(value)
      }
    },
    contracts: {
      get() {
        return Rep_Contracts().get()
      },
      set(value) {
        Rep_Contracts().set(value)
      }
    },
    mode: {
      get() {
        return Rep_Edite_Mode().get()
      },
      set(value) {
        return Rep_Edite_Mode().set(value)
      }
    },
    contract: {
      get() {
        return Rep_Contract().get()
      },
      set(value) {
        Rep_Contract().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    },
    range: {
      get() {
        return Rep_Period().get()
      },
      set(value) {
        Rep_Period().set(value)
      }
    },
    preparedData() {
      return {
        ObjectGUID: this.contract,
        dateStart: this.local_range.start,
        dateEnd: this.local_range.end
      }
    }
  }
}
</script>

<style scoped>

</style>
